module.exports = __webpack_public_path__ + "static/media/rug.7ef2c451.png";